import React, { useState } from 'react';
import styled from '@emotion/styled';
import CategoriesAdmin from '../Admin/Categories/CategoriesAdmin'; // generic one
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  padding: 4rem 2rem;
  margin-bottom: 100px;

@media (max-width: 768px) {
  padding: 20px;
}
`;

const TabButtons = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 1rem;
  place-self:center;

 @media (max-width: 768px) {
    // flex-direction:column;
    text-align:center;
    justify-content:center;
    align-items:center;
    gap:4px;
    margin: 20px 10px;
  }
`;

const TabButton = styled.button`
  padding: 0.5rem 1rem;
  cursor: pointer;
  border: none;
  border-bottom: 1px solid transparent;
  background-color: transparent;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  border-color: ${({ active }) => (active ? '#91abb3' : 'transparent')};
  color: ${({ active }) => (active ? '#91abb3' : '#385963')};

  @media (max-width: 768px) {
   font-size: 12px;
  }
`;

const TabContent = styled.div`
  margin-top: 1rem;
  
    @media (max-width: 768px) {
    padding:0px;
  }
`;

const AllCategoriesAdmin = () => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState('destination');

  const tabOptions = [
    { key: 'destination', label: t('destinations') },
    { key: 'experience', label: t('experiences') },
    { key: 'amenity', label: t('amenities') },
    { key: 'event', label: t('events') },
  ];

  return (
    <Container>

      <TabButtons>
        {tabOptions.map((tab) => (
          <TabButton
            key={tab.key}
            active={currentTab === tab.key}
            onClick={() => setCurrentTab(tab.key)}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabButtons>

      <TabContent>
        <CategoriesAdmin categoryType={currentTab} />
      </TabContent>
    </Container>
  );
};

export default AllCategoriesAdmin;
